// extracted by mini-css-extract-plugin
export default {"productMediaContainer":"productMediaContainer_kmkXR"};